import { useState, useEffect, useRef } from "react";
import "./calendar-page.scss";
import { Calendar, OnlineRestoredNotice } from "components";
import moment from "moment";
import { useGetMeasurerSchedule } from "hooks/orders";
import { convertToEvents } from "utils";
import { useGetMe } from "hooks/auth";
import { usePWA } from "hooks/usePWA";
import { useOfflineQueue } from "hooks/useOfflineQueue";
import { useNavigate } from "react-router";
import { ROUTE_ENUM } from "enums";

const CalendarPage = () => {
  const navigate = useNavigate();
  const { data: authorizedUser } = useGetMe();
  const { isOffline } = usePWA();
  const { getPendingCount } = useOfflineQueue();
  const [requiresSyncAfterReconnect, setRequiresSyncAfterReconnect] =
    useState(false);
  const lastOfflineRef = useRef(isOffline);
  const [date, setDate] = useState(moment().format("YYYY-MM-DD"));

  const [yearStr, monthStr] = date.split("-");
  const month = parseInt(monthStr, 10) || 1;
  const year = parseInt(yearStr, 10) || moment().year();
  const { data: events = [] } = useGetMeasurerSchedule(month, year);

  useEffect(() => {
    if (isOffline === false) {
      const pending = getPendingCount();
      if (pending > 0) {
        setRequiresSyncAfterReconnect(true);
      }
    }
    lastOfflineRef.current = isOffline;
  }, [isOffline, getPendingCount]);

  return (
    <>
      {requiresSyncAfterReconnect && (
        <OnlineRestoredNotice
          message="Przywrócono połączenie z internetem. Aby kontynuować pracę, przejdź do zakładki 'Synchronizacja offline' i wyślij zaległe zmiany."
          actionLabel="Przejdź do synchronizacji"
          onActionClick={() => navigate(ROUTE_ENUM.SYNCHRO_OFFLINE)}
        />
      )}
      {!requiresSyncAfterReconnect && (
        <div className="calendar-page">
          <Calendar
            user={authorizedUser}
            events={convertToEvents(events, "#9DD6FF")}
            date={date}
            setDate={setDate}
            main
            size="100%"
          />
        </div>
      )}
    </>
  );
};

export default CalendarPage;
